// src/store/store.js
import { createStore } from 'vuex'; // For Vue 3, use 'import Vue from "vue"; import Vuex from "vuex"' for Vue 2

export const store = createStore({
    state: {
        user: JSON.parse(localStorage.getItem('bk_admin_user')) || null,
        token: localStorage.getItem('bk_admin_token') || null,
        cart: JSON.parse(localStorage.getItem('bk_cart')) || [],
        wishlist: JSON.parse(localStorage.getItem('bk_wishlist')) || [],
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setToken(state, token) {
            state.token = token;
        },
        logout(state) {
            state.user = null;
            state.token = null;
        },
        addToCart(state, book) {
            const itemInCart = state.cart.find((item) => item._id === book._id);

            if (itemInCart) {
                itemInCart.quantity += 1;
            } else {
                state.cart.push({
                    ...book,
                    quantity: 1,
                });
            }
            localStorage.setItem('bk_cart', JSON.stringify(state.cart));
        },
        // Used when user updates quantity from cat page
        updateCartItemQuantity(state, book) {
            const itemInCart = state.cart.find((item) => item._id === book._id);

            if (itemInCart) {
                itemInCart.quantity = book.quantity;
            }
            localStorage.setItem('bk_cart', JSON.stringify(state.cart));
        },
        removeFromCart(state, bookId) {
            state.cart = state.cart.filter((item) => item._id !== bookId);
            localStorage.setItem('bk_cart', JSON.stringify(state.cart));
        },
        clearCart(state) {
            state.cart = [];
            localStorage.removeItem('bk_cart');
        },
        addToWishlist(state, book) {
            const itemInWishlist = state.wishlist.find(
                (item) => item._id === book._id
            );
            if (!itemInWishlist) {
                state.wishlist.push(book);
                localStorage.setItem(
                    'bk_wishlist',
                    JSON.stringify(state.wishlist)
                );
            }
        },
        removeFromWishlist(state, bookId) {
            state.wishlist = state.wishlist.filter(
                (item) => item._id !== bookId
            );
            localStorage.setItem('bk_wishlist', JSON.stringify(state.wishlist));
        },
        ClearWishlist(state) {
            state.wishlist = [];
            localStorage.removeItem('bk_wishlist');
        },
        loadWishlistFromStorage(state) {
            const storedWishlist = JSON.parse(
                localStorage.getItem('bk_wishlist')
            );
            if (storedWishlist) {
                state.wishlist = storedWishlist;
            }
        },
    },
    actions: {
        login({ commit }, { user, token }) {
            commit('setUser', user);
            commit('setToken', token);
            localStorage.setItem('bk_admin_token', token);
            localStorage.setItem('bk_admin_user', JSON.stringify(user));
            // localStorage.setItem('bk_email', user);
        },
        logout({ commit }) {
            commit('logout');
            localStorage.removeItem('bk_admin_token');
            localStorage.removeItem('bk_admin_user');
        },
        checkLogin({ commit }) {
            const token = localStorage.getItem('bk_admin_token');
            const user = JSON.parse(localStorage.getItem('bk_admin_user'));
            if (token && user) {
                commit('setUser', user);
                commit('setToken', token);
            }
        },
        addToCart({ commit }, book) {
            commit('addToCart', book);
        },
        updateCartItemQuantity({ commit }, book) {
            commit('updateCartItemQuantity', book)
        },
        removeFromCart({ commit }, bookId) {
            commit('removeFromCart', bookId);
        },
        clearCart({ commit }) {
            commit('clearCart');
        },
        addToWishlist({ commit }, book) {
            commit('addToWishlist', book);
        },
        removeFromWishlist({ commit }, bookId) {
            commit('removeFromWishlist', bookId);
        },
        clearWishlist({ commit }) {
            commit('clearWishlist');
        },
        loadWishlistFromStorage({ commit }) {
            commit('loadWishlistFromStorage');
        },
    },
    getters: {
        token: (state) => state.token,
        isLoggedIn: (state) => !!state.user,
        cartItems: (state) => state.cart,
        cartItemCount: (state) => state.cart.length,
        cartTotalPrice: (state) => {
            return state.cart.reduce((total, item) => {
                return total + item.price * item.quantity;
            }, 0);
        },
        cartItemTotalCount: (state) => {
            return state.cart.reduce((count, item) => {
                return count + item.quantity;
            }, 0);
        },
        wishlistItems: (state) => state.wishlist,
        wishlistItemCount: (state) => state.wishlist.length,
    },
});
